<template>
  <img :src="src || fallback" @error="onError" loading="lazy"/>
</template>

<script>
  export default {
    name: 'BaseImg',
    props: {
      src: {
        type: String,
        default: ''
      },
      fallback: {
        type: String,
        default:
          'https://www.raceentry.com/img/Race-Registration-Image-Not-Found.png'
      }
    },
    methods: {
      onError (e) {
        e.target.src = this.fallback
        this.$emit('error')
      }
    }
  }
</script>

<style></style>
